import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';
import { DeserializeOptions } from '@lumapps/wrex/serialization/markdown/fromMarkdown/types';

import type { TDElement } from '../../types';
import { createTable } from '../../utils/createTable';
import { createTD } from '../../utils/createTD';
import { createTR } from '../../utils/createTR';

export const TABLE_ELEMENTS: DeserializeOptions['elements'] = {
    table: {
        convert(_, children) {
            // Mark cells in the first row as header cells
            if (children.length > 0) {
                const firstRow = children[0];
                if (firstRow?.children) {
                    firstRow.children = firstRow.children.map((cell: TDElement) => ({
                        ...cell,
                        isHeader: true,
                    }));
                }
            }
            return createTable({ readOnly: true }, children);
        },
    },
    tableRow: {
        convert: (_, children) => createTR(children),
    },
    tableCell: {
        convert: (_, children) => {
            if (!children.length) {
                // Children can't be empty.
                children.push({ text: '' });
            }
            return createTD([createParagraph(children)]);
        },
    },
};
